import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Switch,
    FormControlLabel
} from '@mui/material';
import Cookies from "js-cookie";
import axios from "axios";
import ConfirmationDialog from "./ConfirmationDialog";

const QueueForm = ({ open, onClose, queueData, onSave, onDelete }) => {
    const [queue, setQueue] = useState(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [pendingToggle, setPendingToggle] = useState(null);

    useEffect(() => {
        if(queueData) {
            setQueue({
                ...queueData,
                startTime: formatDateTime(queueData.startTime),
                endTime: formatDateTime(queueData.endTime)
            });
        } else {
            setQueue({});
        }
    }, [queueData]);

    const handleChange = (event) => {
        setQueue({ ...queue, [event.target.name]: event.target.value });
    };

    const handleToggleChange = (event) => {
        // If toggling isActive, show confirmation dialog
        if (event.target.name === 'isActive') {
            setPendingToggle(event.target.checked);
            setShowConfirmation(true);
        } else {
            setQueue({ ...queue, [event.target.name]: event.target.checked });
        }
    };

    const handleConfirmToggle = () => {
        setQueue({ ...queue, isActive: pendingToggle });
        setShowConfirmation(false);
        setPendingToggle(null);
    };

    const handleCancelToggle = () => {
        setShowConfirmation(false);
        setPendingToggle(null);
    };

    const handleSave = () => {
        onSave(queue);
        onClose();
    };

    const handleDelete = () => {
        onDelete(queue?.queueId);
        onClose();
    };

    // Function to fetch queue from the API
    const fetchQueue = async () => {
        try {
            const csrfToken = Cookies.get('XSRF-TOKEN');
            const response = await axios.get(`/api/queues/staff/${queueData?.queueId}`, {
                headers: {
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            setQueue(response.data);
            //setLoading(false);
        } catch (error) {
            console.error('Error fetching queue', error);
            //setLoading(false);
        }
    };

    const formatDateTime = (dateTimeString) => {
        if (!dateTimeString) return '';
        return dateTimeString.split('.')[0];
    };

    useEffect(() => {
        if(queueData){
            fetchQueue();
            setQueue({
                ...queueData,
                startTime: formatDateTime(queueData.startTime),
                endTime: formatDateTime(queueData.endTime)
            });
        } else {
            setQueue({});
        }
    }, []);

    return (
        <>
            <ConfirmationDialog
                open={showConfirmation}
                onClose={handleCancelToggle}
                onConfirm={handleConfirmToggle}
                title="Warning: Toggling Active Status"
                message="Toggling the Active status will DELETE ALL GROUPS from all queues. This action cannot be undone. Are you sure you want to continue?"
                confirmText="Yes, Continue"
                cancelText="Cancel"
            />
            <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{display: 'flex', justifyContent: 'space-between', marginInline: 3}}>
                {queueData ? `Edit Queue - #${queueData?.queueId}` : 'Add Queue'}
                {queueData && (
                    <Button color="error" onClick={handleDelete} variant="contained">
                        Delete
                    </Button>
                )}
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label="Capacity"
                    type="number"
                    fullWidth
                    name="capacity"
                    value={queue?.capacity}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="Turnaround"
                    type="number"
                    fullWidth
                    name="turnaround"
                    value={queue?.turnaround}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="No-Show Setback"
                    type="number"
                    fullWidth
                    name="noShowSetback"
                    value={queue?.noShowSetback}
                    onChange={handleChange}
                />
                <TextField
                    margin="dense"
                    label="Total Visitors"
                    type="number"
                    disabled
                    fullWidth
                    name="totalVisitors"
                    value={queue?.totalVisitors || 0}
                />
                <TextField
                    margin="dense"
                    label="Start Time"
                    type="datetime-local"
                    fullWidth
                    name="startTime"
                    value={queue?.startTime || ''}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <TextField
                    margin="dense"
                    label="End Time"
                    type="datetime-local"
                    fullWidth
                    name="endTime"
                    value={queue?.endTime || ''}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <FormControlLabel sx={{padding: 2}}
                    control={
                        <Switch
                            checked={queue?.isActive || false}
                            onChange={handleToggleChange}
                            name="isActive"
                        />
                    }
                    label="Is Active"
                />
                <FormControlLabel sx={{padding: 2}}
                    control={
                        <Switch
                            checked={queue?.isCancelled || false}
                            onChange={handleToggleChange}
                            name="isCancelled"
                        />
                    }
                    label="Is Cancelled"
                />
            </DialogContent>
            <DialogActions sx={{display: 'flex', justifyContent: 'space-around ', marginBottom: 2}}>
                <Button onClick={onClose} variant="contained">Cancel</Button>
                <Button onClick={handleSave} variant="contained">Save</Button>
            </DialogActions>
        </Dialog>
        </>
    );
};

export default QueueForm;
